import { Component } from '@angular/core';


import { User } from './_models';

@Component({ selector: 'app', templateUrl: 'app.component.html' ,
styleUrls: ['./app.component.less']})
export class AppComponent {
    user: User;

    constructor() {

    }

}
